import loginStyles from "../../../pages/login/login.module.css";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../services/hooks";
import { errorUserSelector } from "../../../services/selectors/auth.selectors";
import { useActions } from "../../../services/hooks/useActions";
import { useFormik } from "formik";
import { loginSMSValidationSchema } from "../../../utils/validation";
import { adminSelector } from "../../../services/selectors/user.selectors";
import { useSendCodeWithoutLoginMutation } from "../../../services/api/auth.api";
import { TSendCodeWithoutLoginRequest } from "../../../services/types/auth.types";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function LoginSmsForm() {
  const navigate = useNavigate();
  const { setPhone } = useActions();

  const admin = useAppSelector(adminSelector);
  const loginError =
    useAppSelector(errorUserSelector) || t('SOMETHING_WENT_WRONG_TRY_AGAIN_LATER');

  const [sendCodeWithoutLogin, { isError, status }] =
    useSendCodeWithoutLoginMutation();

  const formik = useFormik<TSendCodeWithoutLoginRequest>({
    initialValues: {
      phone: admin.phone || "",
      roleId: "0",
      code: "0",
    },
    validationSchema: loginSMSValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      // Handle form submission
      setPhone(values.phone);
      sendCodeWithoutLogin(values).then((response) => {
        if ("data" in response && response?.data?.success) {
          navigate("enter_code");
        }
      });
      setSubmitting(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className={loginStyles.login__form}>
      <p className={loginStyles.login__formText}>{t('TEXT_MESSAGE_SENT_TO_YOUR')}</p>
      <label htmlFor="name" className={loginStyles.login__label}>
        {t('MY_MOBILE_NUMBER')}</label>
      <input
        type="text"
        className={`${loginStyles.login__input}  ${
          formik.errors.phone && loginStyles.login__input_invalid
        }`}
        name="phone"
        required={true}
        data-testid="phone-number"
        placeholder={t('MOBILE_NUMBER')}
        value={
          formik.values.phone
            ? formik.values.phone.replace(/[^\d+]/g, "")
            : ""
        }
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.errors.phone && (
        <p
          className={`${loginStyles.login__invalid_message}`}
          data-testid="params-error-by-phone"
        >
          {t(formik.errors.phone)}
        </p>
      )}
      {isError && (
        <p
          className={`${loginStyles.login__invalid_message}`}
          data-testid="login-error-by-phone"
        >
          {loginError}
        </p>
      )}
      <button
        type={"submit"}
        disabled={
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
        }
        className={loginStyles.login__restorePasswordLink}
      >
        {/* לא קיבלת הודעה? שלח שוב */}
      </button>
      <button
        type="submit"
        disabled={
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
        }
        className={`button ${loginStyles.login__button} ${
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
            ? loginStyles.login__button_disabled
            : "hover"
        }`}
        data-testid="login-by-sms"
      >
        {status === "pending" ? t('SUBMITTING_LABEL') : t('ENTRANCE')}
      </button>
    </form>
  );
}

export default LoginSmsForm;
